import type { ReactNode } from 'react'
import type { UseFormReturn } from 'react-hook-form'

import { MarkdownEditor } from '@/components/organisms/markdown-editor/markdown-editor.organism'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'

import type { AgencyFormSchemaType } from '../agency-form.schema'

interface AgencyFormLongDescriptionSectionProps {
  form: UseFormReturn<AgencyFormSchemaType>
  isDisabled?: boolean
}

export const AgencyFormLongDescriptionSection = ({
  form,
  isDisabled = false,
}: AgencyFormLongDescriptionSectionProps): ReactNode => (
  <FormField
    control={form.control}
    name="longDescription"
    render={({ field }) => (
      <FormItem>
        <FormLabel>Full Description</FormLabel>
        <FormControl>
          <MarkdownEditor
            initialValue={field.value}
            onChange={field.onChange}
            onBlur={() => field.onBlur()}
            placeholder="Provide a detailed description of your agency..."
            variant="full"
            toolbar="complete"
            minHeight="250px"
            disabled={isDisabled}
            className="agency-form-long-desc-editor"
          />
        </FormControl>
        <FormDescription>Use markdown to format your agency description</FormDescription>
        <FormMessage />
      </FormItem>
    )}
  />
)

AgencyFormLongDescriptionSection.displayName = 'AgencyFormLongDescriptionSection'
